import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GroupsContent from "../Management/groups";
import "./GroupManagement.css";

/**
 * Página standalone de Gestão de Grupos, acessada pelo menu do avatar por um
 * `manager` que NÃO tem acesso ao painel de moderador (FR-001). Quem também é
 * moderador acessa a mesma funcionalidade (GroupsContent) reaproveitando o
 * management-header/management-content dentro de pages/Management (FR-002).
 *
 * Regra permanente desta feature: nenhum arquivo é criado ou executado sem
 * autorização explícita do usuário a cada vez (ver specs/group_administration/plan.md).
 */
function GroupManagement() {
  const { t: tManagement } = useTranslation("management");
  const navigate = useNavigate();

  return (
    <div className="group-management-page">
      <div className="groups-page-header-wrapper">
        <button
          className="groups-page-header-back"
          onClick={() => navigate("/hub")}
        >
          <img src="/imagens/left-arrow_white.svg" alt="" />
        </button>
        <div className="groups-page-header">
          <span>{tManagement("groupManagement")}</span>
        </div>
      </div>
      <GroupsContent />
    </div>
  );
}

export default GroupManagement;
